export function extractYouTubeVideoId(url: string): string | null {
  try {
    const parsedUrl = new URL(url);

    // Case 1: https://www.youtube.com/watch?v=VIDEO_ID
    if (parsedUrl.hostname.includes('youtube.com') && parsedUrl.pathname === '/watch') {
      return parsedUrl.searchParams.get('v');
    }

    // Case 2: https://youtu.be/VIDEO_ID
    if (parsedUrl.hostname === 'youtu.be') {
      return parsedUrl.pathname.split('/')[1];
    }

    // Case 3: https://youtube.com/shorts/VIDEO_ID
    if (parsedUrl.hostname.includes('youtube.com') && parsedUrl.pathname.startsWith('/shorts/')) {
      return parsedUrl.pathname.split('/')[2] || parsedUrl.pathname.split('/')[1];
    }

    // Case 4: https://youtube.com/live/VIDEO_ID
    if (parsedUrl.hostname.includes('youtube.com') && parsedUrl.pathname.startsWith('/live/')) {
      return parsedUrl.pathname.split('/')[2] || parsedUrl.pathname.split('/')[1];
    }

    return null; // Not a recognized format
  } catch (e) {
    return null; // Invalid URL
  }
}
